import { render, staticRenderFns } from "./social-bar.vue?vue&type=template&id=29650de0&scoped=true&"
import script from "./social-bar.vue?vue&type=script&lang=js&"
export * from "./social-bar.vue?vue&type=script&lang=js&"
import style0 from "./social-bar.vue?vue&type=style&index=0&id=29650de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29650de0",
  null
  
)

export default component.exports